import React, { useState } from 'react';
import { AdminAreaChart } from '../../components/admin/AdminChart';
import { AdminMetricCard, AdminPageTitle, DateRange, Panel } from '../../components/admin/AdminPrimitives';
import { communityMetrics, engagementSeriesByRange, type CommunityRange } from '../../data/admin';
import { useLocale } from '../../contexts/LocaleContext';
const periodLabel: Record<CommunityRange, string> = {
  '7d': 'últimos 7 dias',
  '30d': 'últimos 30 dias',
  '90d': 'últimos 90 dias · por semana',
  '12m': 'últimos 12 meses · por mês'
};
export function AdminCommunity() {
  const {
    tl
  } = useLocale();
  const [range, setRange] = useState<CommunityRange>('90d');
  const series = engagementSeriesByRange[range] ?? engagementSeriesByRange['90d'];
  return <div className="space-y-4" data-id="element-1440" data-mp="2843p90bpnzc">
      <AdminPageTitle title="Comunidade" subtitle="Criação de conteúdo, interação e o equilíbrio entre autocuidado e vida social. O período selecionado controla apenas a tendência de engajamento; os indicadores usam uma janela fixa de 30 dias." action={<DateRange value={range} onChange={next => setRange(next as CommunityRange)} data-id="element-1442" data-mp="2sxqsbj3jze53" />} data-id="element-1441" data-mp="g4pxo8x2isoh" />

      <section className="grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-1443" data-mp="2xwuye0v6kvr7">
        {communityMetrics.map(metric => <AdminMetricCard key={metric.id} label={tl(metric.label)} value={metric.value} delta={metric.delta} hint={metric.hint ? tl(metric.hint) : undefined} accent={metric.accent} data-id="element-1444" data-mp="31y6ump8k8f8d" />)}
      </section>

      <AdminAreaChart title={`Tendência de engajamento · ${periodLabel[range]}`} question="O volume de conteúdo cresce junto com a conversa?" data={series} xKey="label" series={[{
      id: 'pulses',
      name: 'Pulses'
    }, {
      id: 'posts',
      name: 'Posts'
    }, {
      id: 'comments',
      name: 'Comentários'
    }]} height={300} data-id="element-1445" data-mp="3gnl2fswhmoln" />

      <Panel title="Equilíbrio entre saúde e social · últimos 30 dias" hint="Janela fixa; não segue o período selecionado." data-id="element-1446" data-mp="1ukuq244qmf0r">
        <ul className="space-y-2" data-id="element-1447" data-mp="1qkkl8usolunh">
          {[['Posts publicados após o Daily Check', '88,1%'], ['Usuários que só consomem conteúdo', '41,2%'], ['Pulses por post publicado', '3,3'], ['Conformidade do gate de Post', '100%']].map(([label, value]) => <li key={label} className="flex items-baseline justify-between gap-3 border-b border-sand-line pb-2 last:border-b-0 last:pb-0" data-id="element-1448" data-mp="2e70rtt17upv0">
              <span className="text-[12.5px] text-deep" data-id="element-1449" data-mp="2n88qwdbk3uq5">{label}</span>
              <span className="bee-num text-[13px] font-bold text-deep" data-id="element-1450" data-mp="2i9xb7lykyq00">{value}</span>
            </li>)}
        </ul>
        <p className="mt-3 text-[11.5px] leading-snug text-muted" data-id="element-1451" data-mp="swag46xlmqs5">
          Conformidade do gate de Post: parcela dos Posts completos publicados somente depois de o
          autor alcançar 50 Bee de base do Daily Check no dia (ou com o benefício único do dia de
          cadastro). Bee de bônus não conta. Pulses não passam pelo gate.
        </p>
      </Panel>
    </div>;
}